module.exports = __webpack_public_path__ + "operace-nosu_8_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_8_after.jpg
// module id = 1141
// module chunks = 0